import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Medallion } from './Medallion';
import { CtaButton } from './CtaButton';
export function GuaranteeSection() {
  return <section className="defer-paint w-full bg-ivory py-10 sm:py-14" aria-labelledby="guarantee-heading" data-id="element-81" data-mp="9ucpp2an3d0j">
      <div className="mx-auto max-w-3xl px-6" data-id="element-82" data-mp="et65509hle3c">
        <div className="rounded-4xl border border-line bg-shell px-7 py-10 text-center shadow-soft sm:px-12" data-id="element-83" data-mp="eu8ydeua7smf">
          <Medallion icon={ShieldCheckIcon} data-id="element-84" data-mp="jsacrmgrj3rk" />

          <p className="eyebrow mt-6 text-navy" data-id="element-85" data-mp="ntvv3nc2ga95">
            🛡️ Your investment is 100% protected
          </p>
          <h2 id="guarantee-heading" className="mx-auto mt-4 max-w-xl font-display text-[1.7rem] font-extrabold leading-[1.12] text-ink sm:text-4xl" data-id="element-86" data-mp="skknd4vklb9c">
            The Iron-Clad 7-Day Guarantee
          </h2>

          <p className="mx-auto mt-6 max-w-readable font-sans text-base leading-relaxed text-stone" data-id="element-87" data-mp="12k37blbhcx1e">
            Access the entire Vault. Use the drills. Teach your toughest student
            this week using our system. If you don’t feel more professional,
            more organised and more confident, email us within 7 days and we
            will refund{' '}
            <span className="font-semibold text-ink" data-id="element-88" data-mp="1vtr5m189nfs0">100% of your money</span>.
            No questions. No hassles.
          </p>

          <div className="mt-9" data-id="element-89" data-mp="1rt7d5ayn10c7">
            <CtaButton variant="navy" data-id="element-90" data-mp="1rtyw9mb1t5ll">Get the Vault risk-free</CtaButton>
          </div>
        </div>
      </div>
    </section>;
}